<div class="access-denied-wrapper">
  <div class="access-denied-header">
    {{ header }}
  </div>
  <div class="access-denied-subtext">
    {{ subtext }}
  </div>
  <div class="access-denied-subtext">
    <a [routerLink]="['/:accountId/mytrack/planning' | url]">Go to MyTrack</a>
  </div>
</div>
